__turbopack_context__.v({
  "imgDark": "s_0Xra_imgDark",
  "imgLight": "s_0Xra_imgLight",
});
